<script>
    import { onMount } from 'svelte'
    import { googleAnalytics } from './google-analytics.js'
    import Landing from './sections/Landing.svelte'
    import Colabora from './sections/Colabora.svelte'
    import Hospitales from './sections/Hospitales.svelte'
    import FAQs from './sections/FAQs.svelte'
    import Navbar from './components/Navbar.svelte'
    import Footer from './components/Footer.svelte'

    onMount(() => {
        googleAnalytics()
    })
</script>

<style type="text/scss">
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvQXBwLnN2ZWx0ZSJ9 */</style>

<main class="relative">
    <Navbar />
    <Landing />
    <Colabora />
    <Hospitales />
    <div class="pb-32">
        <FAQs />
    </div>
    <Footer />
</main>
